var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.appBreakpoint)?_c('Sider',{staticClass:"app-sider",attrs:{"breakpoint":"xs","width":256,"hide-trigger":"","collapsible":"","collapsed-width":80},model:{value:(_vm.collapsed),callback:function ($$v) {_vm.collapsed=$$v},expression:"collapsed"}},[_c('AppMenu')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }